












import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryPlatformAccountList } from '@/api'
import { DateFormat, DateFormat2 } from '@/utils/date/DateUtil'
import { PlatformStatusFormat, PlatformRoleFormat } from '@/utils/tyepconvert'
import RestPwdDialog from './RestPwdDialog.vue'
import CreatePlatformDialog from './components/CreatePlatformDialog.vue'
import ShopUpdatePlatformDialog from './components/ShopUpdatePlatformDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    RestPwdDialog,
    CreatePlatformDialog,
    ShopUpdatePlatformDialog
  },
})
export default class PlatformManager extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    role: 2,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '登录帐号', param: 'account' },
    { title: '邮箱', param: 'email' },
    { title: '手机号', param: 'phoneNo' },
    { title: '归属店铺', param: 'shopName' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '创建账号', type: 'primary', click: () => this.openDialog('CreatePlatformDialog') },
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '登录帐号', param: 'account' },
    { title: '名称', param: 'name' },
    { title: '邮箱', param: 'email' },
    { title: '手机号', param: 'phoneNo' },
    { title: '归属店铺', param: 'shopName' },
    { title: '帐号角色', param: 'role', formatter: PlatformRoleFormat},
    { title: '状态', param: 'status', formatter: PlatformStatusFormat },
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      width: 100,
      operation: [
        {
          title: '编辑',
          icon: 'el-icon-edit',
          click: (data) => this.openDialog('ShopUpdatePlatformDialog', data),
        },
        {
          title: '重置密码',
          icon: 'el-icon-edit',
          click: (data) => this.openDialog('RestPwdDialog', data),
        },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryPlatformAccountList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
  private openDialog(dia: string, data?: any) {
    const f = this.$refs[dia] as any
    f.open(data)
  }
}
